import { TFunction } from "i18next";
import { ISelectListItem } from "../interfaces";
import { BrandType } from "../types";

export function getContractType(t?: TFunction, brand?: BrandType): ISelectListItem<string>[] {
    const ContractType = {
        cupra: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
        seat: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.financing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.financing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.leasing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.leasing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.renting.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.renting.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
        audi: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.financing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.financing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.leasing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.leasing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.renting.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.renting.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
        vw: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.financing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.financing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.leasing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.leasing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.renting.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.renting.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
        vwn: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.financing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.financing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.leasing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.leasing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.renting.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.renting.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
        skoda: [
            {
                id: t ? t("question4page:finance-type.options.financing.value") : "finance",
                displayName: t ? t("question4page:finance-type.options.financing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.financing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.financing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.financing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.financing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.financing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.financing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.leasing.value") : "financelease",
                displayName: t ? t("question4page:finance-type.options.leasing.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.leasing.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.leasing.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.leasing.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.leasing.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.leasing.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.leasing.title") : "",
                icon: "",
            },
            {
                id: t ? t("question4page:finance-type.options.renting.value") : "operatelease",
                displayName: t ? t("question4page:finance-type.options.renting.title") : "",
                description: (
                    <p className="u-ml-small u-mt-xsmall u-text-left u-font-size-fs-1">
                        {t ? t("question4page:finance-type.options.renting.description-two") : ""}{" "}
                        <a
                            href={t ? t("question4page:finance-type.options.renting.description-link") : ""}
                            target="_blank"
                            rel="noreferrer"
                            title={t ? t("question4page:finance-type.options.renting.title") : ""}
                            aria-label={t ? t("question4page:finance-type.options.renting.aria-label") : ""}
                        >
                            {t ? t("question4page:finance-type.options.renting.description-link-title") : ""}
                        </a>
                    </p>
                ),
                value: t ? t("question4page:finance-type.options.renting.title") : "",
                icon: "",
            },
        ],
    };
    return ContractType[brand || (process.env.REACT_APP_WEBSITE_BRAND as BrandType)];
}
